// react components
import React from 'react'
import {
    DropzoneComponent,
} from 'react-dropzone-component'
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material'
import {
    useSelector,
} from 'react-redux'

// data
import {
    contentTypeModelTypeSite,
    defaultReduxState,
} from 'data'

// pages
import {
    Button825,
    IconBlock825,
} from 'pages'

// services
import {
    getApiUrlSiteV2,
} from 'services'

// props
type ImageForm825WeProps = {
    contentType: contentTypeModelTypeSite
    detailObject: any
    filterParams?: string
    refreshData: () => void
    setIsOpen: React.Dispatch<boolean>
    subContentType?: any
}

// main
export const ImageForm825: React.FC<ImageForm825WeProps> = React.memo(({
    contentType,
    detailObject,
    filterParams,
    refreshData,
    setIsOpen,
    subContentType,
}) => {

    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    let myDropzone: any
    function initCallback(dropzone: any) {
        myDropzone = dropzone
    }
    const app = contentType.split('_')[0]
    const param_app = app

    const model = contentType.split('_')[1]
    const config = {
        iconFiletypes: ['.avif', '.gif', '.jpg', '.jpeg', '.png', '.webp'],
        postUrl: getApiUrlSiteV2(`${app}/form/${model}/create/`, reduxModalSite),
        showFiletypeIcon: true,
    }
    const eventHandlers = {
        init: (e: any) => initCallback(e),
        complete: (file: any) => {
            myDropzone.removeFile(file)
            refreshData()
        }
    }
    const djsConfig = {
        acceptedFiles: 'image/avif,image/gif,image/jpeg,image/png,image/webp',
        dictDefaultMessage: reduxText[10213],
        headers: reduxAuth?.axiosConfig?.headers,
        maxFilesize: 64,
        maxThumbnailFilesize: 64,
        parallelUploads: 1,
        paramName: 'image',
        timeout: null,
        params: {
            [param_app]: detailObject.id,
            active: true,
            asset_custom_category: (filterParams?.split('&')?.find((param) => param.includes('asset_custom_category'))?.split('=')[1]) || '',
            content_object_id: detailObject.id,
            content_type: detailObject.model_content_type_id,
            profile: detailObject.profile?.id,
            sub_content_type: subContentType ? subContentType.id : 220,
        },
        // error: (file: any, message: any) => {  // TODO
        //     myDropzone.removeFile(file)
        //     alert(message)
        // }
    }

    return (
        <Dialog
            className='image-form-825'
            classes={{ paper: 'mo-dialog-wrapper' }}
            disableEnforceFocus
            maxWidth='xl'
            onClose={() => setIsOpen(false)}
            open
        >
            <DialogTitle className='mo-dialog-header'>
                <div className='mo-dialog-header-close-wrap'>
                    <IconBlock825
                        className='mo-dialog-header-close'
                        edit={false}
                        iconClass='mo-new-icon-times-solid'
                        onClick={() => setIsOpen(false)}
                    />
                </div>
            </DialogTitle>
            <DialogContent className={`mo-dialog-content mo-hidden-vertical-scrollbar${reduxModalSite.isWindows}`}>
                <div className='if-input'>
                    <DropzoneComponent
                        config={config}
                        djsConfig={djsConfig}
                        eventHandlers={eventHandlers}
                    />
                </div>
            </DialogContent>
            <DialogActions className='mo-dialog-footer'>
                <Button825
                    edit={false}
                    onClick={() => setIsOpen(false)}
                    size='small'
                    text={reduxText[10214]}
                />
            </DialogActions>
        </Dialog>
    )
})
